import { Injectable, Injector } from '@angular/core';
import { IBreadcrumbsService } from '../../general/interfaces/breadcrumbs-service.interface';
import { Breadcrumb } from '../../general/models/breadcrumb';
import { BookingStepEnum } from '../models/booking-step.enum';

@Injectable()
export class BookingBreadcrumbsService implements IBreadcrumbsService {

  private _breadcrumbs: Breadcrumb[];

  get hasActiveBreadcrumbs(): boolean {
    return this._breadcrumbs && this._breadcrumbs.length > 0;
  }

  get breadcrumbs(): Breadcrumb[] {
    return this._breadcrumbs;
  }

  reload(state: BookingStepEnum, isEvents: boolean): void {
    if (state >= BookingStepEnum.ShowOrder) {
      this._breadcrumbs = [];
      return;
    }

    this._breadcrumbs = [
      new Breadcrumb(
        'Home',
        '/',
        true,
        0),
    ];

    this._breadcrumbs.push(
      new Breadcrumb(
        'What',
        isEvents ? '/booking/events' : '/booking',
        true,
        1));

    if (!isEvents) {
      this._breadcrumbs.push(
        new Breadcrumb(
          'When',
          isEvents ? '/booking/events' : '/booking/slots',
          state >= BookingStepEnum.SelectBookingPacks,
          2));
    }

    this._breadcrumbs.push(
      new Breadcrumb(
        'Who',
        isEvents ? '/booking/events/product' : '/booking/single/product',
        state >= BookingStepEnum.SelectNearestBookingSingleProducts,
        3));

    this._breadcrumbs.push(
      new Breadcrumb(
        'Payment',
        '/',
        false,
        4));
  }
}
